import ElementPage from "../../Elements";

// pages/TermsCondition.jsx
export default function TermsCondition() {
  return (
    <>
      <div style={styles.container} className="py-2">
        <div className="jtext-justify" style={{ fontFamily: "serif" }}>
          <h6 className="mt-1" style={{ color: "#FF4F00" }}>
            Terms & Conditions
          </h6>
          <p className="text-gray-700 fs-6">
            This Website is operated by Khunkhaar Meldi Maa Bareja Foundation
          </p>
          <b className="text-gray-700 fs-6">1. Introduction</b>
          <p className="mb-2 text-gray-600">
            Welcome to khunkhaarmeldimaabareja.com (“Website”, “we”, “our”,
            “us”). By accessing or using this Website, you agree to these Terms
            & Conditions.
          </p>

          <b className="text-gray-700 fs-6">2. Purpose</b>
          <p className="mb-2 text-gray-600">
            The Website facilitates devotional participation related to LORD
            RAM, including purchase of a blank book, digital RAM name counting,
            and submission of completed books.
          </p>
          <b className="text-gray-700 fs-6">3. User Registration</b>
          <p className="mb-2 text-gray-600">
            Users must provide accurate information and are responsible for
            their account activities.
          </p>
          <b className="text-gray-700 fs-6">4. Book Purchase</b>
          <p className="mb-2 text-gray-600">
            The book price is ₹1 (fixed price). The book is blank and intended
            only for writing the name of LORD RAM.
          </p>

          <b className="text-gray-700 fs-6">5. Writing & Submission</b>
          <p className="mb-2 text-gray-600">
            Books must be filled manually. Once submitted, books will not be
            returned.
          </p>

          <b className="text-gray-700 fs-6">6. Digital RAM Count</b>
          <p className="mb-2 text-gray-600">
            The digital count is symbolic, devotional, and holds no monetary
            value.
          </p>

          <b className="text-gray-700 fs-6">7. Payments</b>
          <p className="mb-2 text-gray-600">
            Payments are non-refundable once completed.
          </p>

          <b className="text-gray-700 fs-6">8. Delivery</b>
          <p className="mb-2 text-gray-600">
            Delivery timelines are approximate and may vary.
          </p>
          <b className="text-gray-700 fs-6">9. Disclaimer</b>
          <p className="mb-2 text-gray-600">
            All activities are faith-based and devotional.
          </p>
          <b className="text-gray-700 fs-6">10. Governing Law</b>
          <p className="text-gray-600">
            These Terms are governed by the laws of India.
          </p>
        </div>
      </div>
      <ElementPage />
    </>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "0 20px",
    lineHeight: "1.7",
  },
};
